// GENERATED by scripts/extract-mock-occupations.mjs from the checked-in package src/EPN.Employees.Api/SeedData/occupation-reference.
// A small subset of REAL occupations (codes, titles, shortened descriptions, reported titles) for MockJobRoleGateway. Do not edit by hand;
// mockOccupationData.test.ts fails if anything here is not in the package. Source: O*NET 31.0 (CC BY 4.0), see the attribution in the datasets.

export interface MockOccupationRecord {
  system: 'Soc' | 'Onet';
  code: string;
  title: string;
  description: string | null;
  majorGroupCode: string;
  majorGroupName: string;
  socCode: string;
}

export interface MockOccupationDataset {
  system: 'Soc' | 'Onet';
  name: string;
  version: string;
  sourceOrganization: string;
  derivedFrom: string;
  sourceUrl: string;
  limitation: string;
  retrievedOn: string;
  licenseName: string;
  licenseUrl: string;
  attributionText: string;
}

export const MOCK_OCCUPATION_DATASETS: MockOccupationDataset[] = [
  {
    "system": "Soc",
    "name": "Standard Occupational Classification (SOC) 2018, detailed occupations",
    "version": "2018",
    "sourceOrganization": "U.S. Bureau of Labor Statistics (SOC); list and titles as carried in the O*NET-SOC taxonomy",
    "derivedFrom": "O*NET 31.0 Database, Occupation Data, records whose O*NET-SOC code ends in .00",
    "sourceUrl": "https://www.onetcenter.org/database.html",
    "limitation": "The official BLS 2018 SOC definitions file could not be downloaded (HTTP 403), so titles are those carried in the O*NET database and may differ in minor wording from the BLS publication. Verify against https://www.bls.gov/soc/2018/ before relying on a title for a regulatory purpose.",
    "retrievedOn": "2026-10-20",
    "licenseName": "Creative Commons Attribution 4.0 International (CC BY 4.0)",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/",
    "attributionText": "This product includes information from the O*NET 31.0 Database by the U.S. Department of Labor, Employment and Training Administration (USDOL/ETA), used under the CC BY 4.0 license (https://creativecommons.org/licenses/by/4.0/). O*NET® is a trademark of USDOL/ETA. EPN selected fields from the database, reformatted them, and derived a Standard Occupational Classification list from the occupation records whose O*NET-SOC code ends in \".00\". USDOL/ETA has not approved, endorsed or tested these modifications."
  },
  {
    "system": "Onet",
    "name": "O*NET-SOC occupations (O*NET 31.0)",
    "version": "O*NET 31.0",
    "sourceOrganization": "U.S. Department of Labor, Employment and Training Administration (O*NET)",
    "derivedFrom": "O*NET 31.0 Database, Occupation Data and Sample of Reported Titles",
    "sourceUrl": "https://www.onetcenter.org/database.html",
    "limitation": "Reported titles are a sample, not an exhaustive list of titles used in the labor market.",
    "retrievedOn": "2026-10-20",
    "licenseName": "Creative Commons Attribution 4.0 International (CC BY 4.0)",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/",
    "attributionText": "This product includes information from the O*NET 31.0 Database by the U.S. Department of Labor, Employment and Training Administration (USDOL/ETA), used under the CC BY 4.0 license (https://creativecommons.org/licenses/by/4.0/). O*NET® is a trademark of USDOL/ETA. EPN selected fields from the database, reformatted them, and derived a Standard Occupational Classification list from the occupation records whose O*NET-SOC code ends in \".00\". USDOL/ETA has not approved, endorsed or tested these modifications."
  }
];

export const MOCK_OCCUPATIONS: MockOccupationRecord[] = [
  {
    "system": "Soc",
    "code": "11-1011",
    "title": "Chief Executives",
    "description": "Determine and formulate policies and provide overall direction of companies or private and public sector organizations within guidelines set up by a board of directors or similar governing body.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-1011"
  },
  {
    "system": "Soc",
    "code": "11-1021",
    "title": "General and Operations Managers",
    "description": "Plan, direct, or coordinate the operations of public or private sector organizations, overseeing multiple departments or locations.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-1021"
  },
  {
    "system": "Soc",
    "code": "11-2021",
    "title": "Marketing Managers",
    "description": "Plan, direct, or coordinate marketing policies and programs, such as determining the demand for products and services offered by a firm and its competitors, and identify potential customers.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-2021"
  },
  {
    "system": "Soc",
    "code": "11-3012",
    "title": "Administrative Services Managers",
    "description": "Plan, direct, or coordinate one or more administrative services of an organization, such as records and information management, mail distribution, and other office support services.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3012"
  },
  {
    "system": "Soc",
    "code": "11-3021",
    "title": "Computer and Information Systems Managers",
    "description": "Plan, direct, or coordinate activities in such fields as electronic data processing, information systems, systems analysis, and computer programming.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3021"
  },
  {
    "system": "Soc",
    "code": "11-3031",
    "title": "Financial Managers",
    "description": "Plan, direct, or coordinate accounting, investing, banking, insurance, securities, and other financial activities of a branch, office, or department of an establishment.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3031"
  },
  {
    "system": "Soc",
    "code": "11-3111",
    "title": "Compensation and Benefits Managers",
    "description": "Plan, direct, or coordinate compensation and benefits activities of an organization.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3111"
  },
  {
    "system": "Soc",
    "code": "11-3121",
    "title": "Human Resources Managers",
    "description": "Plan, direct, or coordinate human resources activities and staff of an organization.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3121"
  },
  {
    "system": "Soc",
    "code": "13-1071",
    "title": "Human Resources Specialists",
    "description": "Recruit, screen, interview, or place individuals within an organization. May perform other activities in multiple human resources areas.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-1071"
  },
  {
    "system": "Soc",
    "code": "13-1111",
    "title": "Management Analysts",
    "description": "Conduct organizational studies and evaluations, design systems and procedures, conduct work simplification and measurement studies, and prepare operations and procedures manuals to assist management in operating more efficiently and effectively. Includes program analysts and management consultants.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-1111"
  },
  {
    "system": "Soc",
    "code": "13-1151",
    "title": "Training and Development Specialists",
    "description": "Design or conduct work-related training and development programs to improve individual skills or organizational performance. May analyze organizational training needs or evaluate training effectiveness.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-1151"
  },
  {
    "system": "Soc",
    "code": "13-2011",
    "title": "Accountants and Auditors",
    "description": "Examine, analyze, and interpret accounting records to prepare financial statements, give advice, or audit and evaluate statements prepared by others. Install or advise on systems of recording costs or other financial and budgetary data.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-2011"
  },
  {
    "system": "Soc",
    "code": "13-2051",
    "title": "Financial and Investment Analysts",
    "description": "Conduct quantitative analyses of information involving investment programs or financial data of public or private institutions, including valuation of businesses.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-2051"
  },
  {
    "system": "Soc",
    "code": "15-1211",
    "title": "Computer Systems Analysts",
    "description": "Analyze science, engineering, business, and other data processing problems to develop and implement solutions to complex applications problems, system administration issues, or network concerns.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1211"
  },
  {
    "system": "Soc",
    "code": "15-1232",
    "title": "Computer User Support Specialists",
    "description": "Provide technical assistance to computer users. Answer questions or resolve computer problems for clients in person, via telephone, or electronically.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1232"
  },
  {
    "system": "Soc",
    "code": "15-1244",
    "title": "Network and Computer Systems Administrators",
    "description": "Install, configure, and maintain an organization's local area network (LAN), wide area network (WAN), data communications network, operating systems, and physical and virtual servers.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1244"
  },
  {
    "system": "Soc",
    "code": "15-1252",
    "title": "Software Developers",
    "description": "Research, design, and develop computer and network software or specialized utility programs. Analyze user needs and develop software solutions, applying principles and techniques of computer science, engineering, and mathematical analysis. Update software or enhance existing software capabilities.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1252"
  },
  {
    "system": "Soc",
    "code": "15-2051",
    "title": "Data Scientists",
    "description": "Develop and implement a set of techniques or analytics applications to transform raw data into meaningful information using data-oriented programming languages and visualization software.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-2051"
  },
  {
    "system": "Soc",
    "code": "23-1011",
    "title": "Lawyers",
    "description": "Represent clients in criminal and civil litigation and other legal proceedings, draw up legal documents, or manage or advise clients on legal transactions. May specialize in a single area or may practice broadly in many areas of law.",
    "majorGroupCode": "23-0000",
    "majorGroupName": "Legal Occupations",
    "socCode": "23-1011"
  },
  {
    "system": "Soc",
    "code": "41-4012",
    "title": "Sales Representatives, Wholesale and Manufacturing, Except Technical and Scientific Products",
    "description": "Sell goods for wholesalers or manufacturers to businesses or groups of individuals. Work requires substantial knowledge of items sold.",
    "majorGroupCode": "41-0000",
    "majorGroupName": "Sales and Related Occupations",
    "socCode": "41-4012"
  },
  {
    "system": "Soc",
    "code": "43-1011",
    "title": "First-Line Supervisors of Office and Administrative Support Workers",
    "description": "Directly supervise and coordinate the activities of clerical and administrative support workers.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-1011"
  },
  {
    "system": "Soc",
    "code": "43-3021",
    "title": "Billing and Posting Clerks",
    "description": "Compile, compute, and record billing, accounting, statistical, and other numerical data for billing purposes. Prepare billing invoices for services rendered or for delivery or shipment of goods.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-3021"
  },
  {
    "system": "Soc",
    "code": "43-3031",
    "title": "Bookkeeping, Accounting, and Auditing Clerks",
    "description": "Compute, classify, and record numerical data to keep financial records complete. Perform any combination of routine calculating, posting, and verifying duties to obtain primary financial data for use in maintaining accounting records.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-3031"
  },
  {
    "system": "Soc",
    "code": "43-3051",
    "title": "Payroll and Timekeeping Clerks",
    "description": "Compile and record employee time and payroll data. May compute employees' time worked, production, and commission. May compute and post wages and deductions, or prepare paychecks.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-3051"
  },
  {
    "system": "Soc",
    "code": "43-4051",
    "title": "Customer Service Representatives",
    "description": "Interact with customers to provide basic or scripted information in response to routine inquiries about products and services. May handle and resolve general complaints. Excludes individuals whose duties are primarily installation, sales, repair, and technical support.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-4051"
  },
  {
    "system": "Soc",
    "code": "43-4161",
    "title": "Human Resources Assistants, Except Payroll and Timekeeping",
    "description": "Compile and keep personnel records. Record data for each employee, such as address, weekly earnings, absences, amount of sales or production, supervisory reports, and date of and reason for termination.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-4161"
  },
  {
    "system": "Soc",
    "code": "43-6011",
    "title": "Executive Secretaries and Executive Administrative Assistants",
    "description": "Provide high-level administrative support by conducting research, preparing statistical reports, and handling information requests, as well as performing routine administrative functions such as preparing correspondence, receiving visitors, arranging conference calls, and scheduling meetings.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-6011"
  },
  {
    "system": "Soc",
    "code": "43-6014",
    "title": "Secretaries and Administrative Assistants, Except Legal, Medical, and Executive",
    "description": "Perform routine administrative functions such as drafting correspondence, scheduling appointments, organizing and maintaining paper and electronic files, or providing information to callers.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-6014"
  },
  {
    "system": "Soc",
    "code": "43-9061",
    "title": "Office Clerks, General",
    "description": "Perform duties too varied and diverse to be classified in any specific office clerical occupation, requiring knowledge of office systems and procedures.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-9061"
  },
  {
    "system": "Soc",
    "code": "53-3032",
    "title": "Heavy and Tractor-Trailer Truck Drivers",
    "description": "Drive a tractor-trailer combination or a truck with a capacity of at least 26,001 pounds Gross Vehicle Weight (GVW). May be required to unload truck. Requires commercial drivers' license. Includes tow truck drivers.",
    "majorGroupCode": "53-0000",
    "majorGroupName": "Transportation and Material Moving Occupations",
    "socCode": "53-3032"
  },
  {
    "system": "Onet",
    "code": "11-1011.00",
    "title": "Chief Executives",
    "description": "Determine and formulate policies and provide overall direction of companies or private and public sector organizations within guidelines set up by a board of directors or similar governing body.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-1011"
  },
  {
    "system": "Onet",
    "code": "11-1021.00",
    "title": "General and Operations Managers",
    "description": "Plan, direct, or coordinate the operations of public or private sector organizations, overseeing multiple departments or locations.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-1021"
  },
  {
    "system": "Onet",
    "code": "11-2021.00",
    "title": "Marketing Managers",
    "description": "Plan, direct, or coordinate marketing policies and programs, such as determining the demand for products and services offered by a firm and its competitors, and identify potential customers.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-2021"
  },
  {
    "system": "Onet",
    "code": "11-3012.00",
    "title": "Administrative Services Managers",
    "description": "Plan, direct, or coordinate one or more administrative services of an organization, such as records and information management, mail distribution, and other office support services.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3012"
  },
  {
    "system": "Onet",
    "code": "11-3021.00",
    "title": "Computer and Information Systems Managers",
    "description": "Plan, direct, or coordinate activities in such fields as electronic data processing, information systems, systems analysis, and computer programming.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3021"
  },
  {
    "system": "Onet",
    "code": "11-3031.00",
    "title": "Financial Managers",
    "description": "Plan, direct, or coordinate accounting, investing, banking, insurance, securities, and other financial activities of a branch, office, or department of an establishment.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3031"
  },
  {
    "system": "Onet",
    "code": "11-3031.01",
    "title": "Treasurers and Controllers",
    "description": "Direct financial activities, such as planning, procurement, and investments for all or part of an organization.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3031"
  },
  {
    "system": "Onet",
    "code": "11-3031.03",
    "title": "Investment Fund Managers",
    "description": "Plan, direct, or coordinate investment strategy or operations for a large pool of liquid assets supplied by institutional investors or individual investors.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3031"
  },
  {
    "system": "Onet",
    "code": "11-3111.00",
    "title": "Compensation and Benefits Managers",
    "description": "Plan, direct, or coordinate compensation and benefits activities of an organization.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3111"
  },
  {
    "system": "Onet",
    "code": "11-3121.00",
    "title": "Human Resources Managers",
    "description": "Plan, direct, or coordinate human resources activities and staff of an organization.",
    "majorGroupCode": "11-0000",
    "majorGroupName": "Management Occupations",
    "socCode": "11-3121"
  },
  {
    "system": "Onet",
    "code": "13-1071.00",
    "title": "Human Resources Specialists",
    "description": "Recruit, screen, interview, or place individuals within an organization. May perform other activities in multiple human resources areas.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-1071"
  },
  {
    "system": "Onet",
    "code": "13-1111.00",
    "title": "Management Analysts",
    "description": "Conduct organizational studies and evaluations, design systems and procedures, conduct work simplification and measurement studies, and prepare operations and procedures manuals to assist management in operating more efficiently and effectively. Includes program analysts and management consultants.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-1111"
  },
  {
    "system": "Onet",
    "code": "13-1151.00",
    "title": "Training and Development Specialists",
    "description": "Design or conduct work-related training and development programs to improve individual skills or organizational performance. May analyze organizational training needs or evaluate training effectiveness.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-1151"
  },
  {
    "system": "Onet",
    "code": "13-2011.00",
    "title": "Accountants and Auditors",
    "description": "Examine, analyze, and interpret accounting records to prepare financial statements, give advice, or audit and evaluate statements prepared by others. Install or advise on systems of recording costs or other financial and budgetary data.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-2011"
  },
  {
    "system": "Onet",
    "code": "13-2051.00",
    "title": "Financial and Investment Analysts",
    "description": "Conduct quantitative analyses of information involving investment programs or financial data of public or private institutions, including valuation of businesses.",
    "majorGroupCode": "13-0000",
    "majorGroupName": "Business and Financial Operations Occupations",
    "socCode": "13-2051"
  },
  {
    "system": "Onet",
    "code": "15-1211.00",
    "title": "Computer Systems Analysts",
    "description": "Analyze science, engineering, business, and other data processing problems to develop and implement solutions to complex applications problems, system administration issues, or network concerns.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1211"
  },
  {
    "system": "Onet",
    "code": "15-1211.01",
    "title": "Health Informatics Specialists",
    "description": "Apply knowledge of nursing and informatics to assist in the design, development, and ongoing modification of computerized health care systems. May educate staff and assist in problem solving to promote the implementation of the health care system.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1211"
  },
  {
    "system": "Onet",
    "code": "15-1232.00",
    "title": "Computer User Support Specialists",
    "description": "Provide technical assistance to computer users. Answer questions or resolve computer problems for clients in person, via telephone, or electronically.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1232"
  },
  {
    "system": "Onet",
    "code": "15-1244.00",
    "title": "Network and Computer Systems Administrators",
    "description": "Install, configure, and maintain an organization's local area network (LAN), wide area network (WAN), data communications network, operating systems, and physical and virtual servers.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1244"
  },
  {
    "system": "Onet",
    "code": "15-1252.00",
    "title": "Software Developers",
    "description": "Research, design, and develop computer and network software or specialized utility programs. Analyze user needs and develop software solutions, applying principles and techniques of computer science, engineering, and mathematical analysis. Update software or enhance existing software capabilities.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-1252"
  },
  {
    "system": "Onet",
    "code": "15-2051.00",
    "title": "Data Scientists",
    "description": "Develop and implement a set of techniques or analytics applications to transform raw data into meaningful information using data-oriented programming languages and visualization software.",
    "majorGroupCode": "15-0000",
    "majorGroupName": "Computer and Mathematical Occupations",
    "socCode": "15-2051"
  },
  {
    "system": "Onet",
    "code": "23-1011.00",
    "title": "Lawyers",
    "description": "Represent clients in criminal and civil litigation and other legal proceedings, draw up legal documents, or manage or advise clients on legal transactions. May specialize in a single area or may practice broadly in many areas of law.",
    "majorGroupCode": "23-0000",
    "majorGroupName": "Legal Occupations",
    "socCode": "23-1011"
  },
  {
    "system": "Onet",
    "code": "41-4012.00",
    "title": "Sales Representatives, Wholesale and Manufacturing, Except Technical and Scientific Products",
    "description": "Sell goods for wholesalers or manufacturers to businesses or groups of individuals. Work requires substantial knowledge of items sold.",
    "majorGroupCode": "41-0000",
    "majorGroupName": "Sales and Related Occupations",
    "socCode": "41-4012"
  },
  {
    "system": "Onet",
    "code": "43-1011.00",
    "title": "First-Line Supervisors of Office and Administrative Support Workers",
    "description": "Directly supervise and coordinate the activities of clerical and administrative support workers.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-1011"
  },
  {
    "system": "Onet",
    "code": "43-3021.00",
    "title": "Billing and Posting Clerks",
    "description": "Compile, compute, and record billing, accounting, statistical, and other numerical data for billing purposes. Prepare billing invoices for services rendered or for delivery or shipment of goods.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-3021"
  },
  {
    "system": "Onet",
    "code": "43-3031.00",
    "title": "Bookkeeping, Accounting, and Auditing Clerks",
    "description": "Compute, classify, and record numerical data to keep financial records complete. Perform any combination of routine calculating, posting, and verifying duties to obtain primary financial data for use in maintaining accounting records.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-3031"
  },
  {
    "system": "Onet",
    "code": "43-3051.00",
    "title": "Payroll and Timekeeping Clerks",
    "description": "Compile and record employee time and payroll data. May compute employees' time worked, production, and commission. May compute and post wages and deductions, or prepare paychecks.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-3051"
  },
  {
    "system": "Onet",
    "code": "43-4051.00",
    "title": "Customer Service Representatives",
    "description": "Interact with customers to provide basic or scripted information in response to routine inquiries about products and services. May handle and resolve general complaints. Excludes individuals whose duties are primarily installation, sales, repair, and technical support.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-4051"
  },
  {
    "system": "Onet",
    "code": "43-4161.00",
    "title": "Human Resources Assistants, Except Payroll and Timekeeping",
    "description": "Compile and keep personnel records. Record data for each employee, such as address, weekly earnings, absences, amount of sales or production, supervisory reports, and date of and reason for termination.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-4161"
  },
  {
    "system": "Onet",
    "code": "43-6011.00",
    "title": "Executive Secretaries and Executive Administrative Assistants",
    "description": "Provide high-level administrative support by conducting research, preparing statistical reports, and handling information requests, as well as performing routine administrative functions such as preparing correspondence, receiving visitors, arranging conference calls, and scheduling meetings.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-6011"
  },
  {
    "system": "Onet",
    "code": "43-6014.00",
    "title": "Secretaries and Administrative Assistants, Except Legal, Medical, and Executive",
    "description": "Perform routine administrative functions such as drafting correspondence, scheduling appointments, organizing and maintaining paper and electronic files, or providing information to callers.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-6014"
  },
  {
    "system": "Onet",
    "code": "43-9061.00",
    "title": "Office Clerks, General",
    "description": "Perform duties too varied and diverse to be classified in any specific office clerical occupation, requiring knowledge of office systems and procedures.",
    "majorGroupCode": "43-0000",
    "majorGroupName": "Office and Administrative Support Occupations",
    "socCode": "43-9061"
  },
  {
    "system": "Onet",
    "code": "53-3032.00",
    "title": "Heavy and Tractor-Trailer Truck Drivers",
    "description": "Drive a tractor-trailer combination or a truck with a capacity of at least 26,001 pounds Gross Vehicle Weight (GVW). May be required to unload truck. Requires commercial drivers' license. Includes tow truck drivers.",
    "majorGroupCode": "53-0000",
    "majorGroupName": "Transportation and Material Moving Occupations",
    "socCode": "53-3032"
  }
];

export const MOCK_OCCUPATION_TITLES: { onetCode: string; title: string }[] = [
  {
    "onetCode": "11-1011.00",
    "title": "CEO (Chief Executive Officer)"
  },
  {
    "onetCode": "11-1011.00",
    "title": "Chief Diversity Officer (CDO)"
  },
  {
    "onetCode": "11-1011.00",
    "title": "Chief Financial Officer (CFO)"
  },
  {
    "onetCode": "11-1011.00",
    "title": "Chief Information Officer (CIO)"
  },
  {
    "onetCode": "11-1011.00",
    "title": "Chief Operating Officer (COO)"
  },
  {
    "onetCode": "11-1011.00",
    "title": "Chief Technical Officer (CTO)"
  },
  {
    "onetCode": "11-1011.00",
    "title": "Executive Director"
  },
  {
    "onetCode": "11-1011.00",
    "title": "Executive Vice President (EVP)"
  },
  {
    "onetCode": "11-1021.00",
    "title": "Business Manager"
  },
  {
    "onetCode": "11-1021.00",
    "title": "Center Manager"
  },
  {
    "onetCode": "11-1021.00",
    "title": "Department Manager"
  },
  {
    "onetCode": "11-1021.00",
    "title": "District Manager"
  },
  {
    "onetCode": "11-1021.00",
    "title": "General Manager (GM)"
  },
  {
    "onetCode": "11-1021.00",
    "title": "Operations Director"
  },
  {
    "onetCode": "11-1021.00",
    "title": "Operations General Manager (Operations GM)"
  },
  {
    "onetCode": "11-1021.00",
    "title": "Operations Manager"
  },
  {
    "onetCode": "11-2021.00",
    "title": "BD Director (Business Development Director)"
  },
  {
    "onetCode": "11-2021.00",
    "title": "BD Manager (Business Development Manager)"
  },
  {
    "onetCode": "11-2021.00",
    "title": "Brand Manager"
  },
  {
    "onetCode": "11-2021.00",
    "title": "Market Development Executive"
  },
  {
    "onetCode": "11-2021.00",
    "title": "Market Development Manager"
  },
  {
    "onetCode": "11-2021.00",
    "title": "Marketing Communications Manager"
  },
  {
    "onetCode": "11-2021.00",
    "title": "Marketing Coordinator"
  },
  {
    "onetCode": "11-2021.00",
    "title": "Marketing Director"
  },
  {
    "onetCode": "11-3012.00",
    "title": "Administrative Coordinator"
  },
  {
    "onetCode": "11-3012.00",
    "title": "Administrative Director"
  },
  {
    "onetCode": "11-3012.00",
    "title": "Administrative Manager"
  },
  {
    "onetCode": "11-3012.00",
    "title": "Administrative Officer"
  },
  {
    "onetCode": "11-3012.00",
    "title": "Administrator"
  },
  {
    "onetCode": "11-3012.00",
    "title": "Business Administrator"
  },
  {
    "onetCode": "11-3012.00",
    "title": "Business Manager"
  },
  {
    "onetCode": "11-3021.00",
    "title": "Application Development Director"
  },
  {
    "onetCode": "11-3021.00",
    "title": "Computing Services Director"
  },
  {
    "onetCode": "11-3021.00",
    "title": "Data Processing Manager"
  },
  {
    "onetCode": "11-3021.00",
    "title": "Information Systems Director (IS Director)"
  },
  {
    "onetCode": "11-3021.00",
    "title": "Information Systems Manager (IS Manager)"
  },
  {
    "onetCode": "11-3021.00",
    "title": "Information Systems Supervisor (IS Supervisor)"
  },
  {
    "onetCode": "11-3021.00",
    "title": "Information Technology Director (IT Director)"
  },
  {
    "onetCode": "11-3021.00",
    "title": "Information Technology Manager (IT Manager)"
  },
  {
    "onetCode": "11-3031.00",
    "title": "Accounting Supervisor"
  },
  {
    "onetCode": "11-3031.00",
    "title": "Banking Center Manager (BCM)"
  },
  {
    "onetCode": "11-3031.00",
    "title": "Branch Manager"
  },
  {
    "onetCode": "11-3031.00",
    "title": "Business Banking Manager"
  },
  {
    "onetCode": "11-3031.00",
    "title": "Credit Administration Manager"
  },
  {
    "onetCode": "11-3031.00",
    "title": "Credit Manager"
  },
  {
    "onetCode": "11-3031.00",
    "title": "Financial Center Manager"
  },
  {
    "onetCode": "11-3031.00",
    "title": "Financial Planning Manager"
  },
  {
    "onetCode": "11-3031.01",
    "title": "Comptroller"
  },
  {
    "onetCode": "11-3031.01",
    "title": "Controller"
  },
  {
    "onetCode": "11-3031.01",
    "title": "Corporate Controller"
  },
  {
    "onetCode": "11-3031.01",
    "title": "Corporate Treasurer"
  },
  {
    "onetCode": "11-3031.01",
    "title": "Finance Treasurer"
  },
  {
    "onetCode": "11-3031.01",
    "title": "Global Treasurer"
  },
  {
    "onetCode": "11-3031.01",
    "title": "Regional Controller"
  },
  {
    "onetCode": "11-3031.01",
    "title": "School Treasurer"
  },
  {
    "onetCode": "11-3031.03",
    "title": "Fixed Income Portfolio Manager"
  },
  {
    "onetCode": "11-3031.03",
    "title": "Fixed Income Vice President (Fixed Income VP)"
  },
  {
    "onetCode": "11-3031.03",
    "title": "Investment Analysis Vice President (Investment Analysis VP)"
  },
  {
    "onetCode": "11-3031.03",
    "title": "Portfolio Manager"
  },
  {
    "onetCode": "11-3111.00",
    "title": "Benefits Coordinator"
  },
  {
    "onetCode": "11-3111.00",
    "title": "Benefits Director"
  },
  {
    "onetCode": "11-3111.00",
    "title": "Benefits Manager"
  },
  {
    "onetCode": "11-3111.00",
    "title": "Compensation and Benefits Director"
  },
  {
    "onetCode": "11-3111.00",
    "title": "Compensation and Benefits Manager"
  },
  {
    "onetCode": "11-3111.00",
    "title": "Compensation Director"
  },
  {
    "onetCode": "11-3111.00",
    "title": "Compensation Manager"
  },
  {
    "onetCode": "11-3111.00",
    "title": "Employee Benefits Coordinator"
  },
  {
    "onetCode": "11-3121.00",
    "title": "Employee Relations Manager"
  },
  {
    "onetCode": "11-3121.00",
    "title": "HR Admin Director (Human Resources Administration Director)"
  },
  {
    "onetCode": "11-3121.00",
    "title": "HR Director (Human Resources Director)"
  },
  {
    "onetCode": "11-3121.00",
    "title": "HR Manager (Human Resources Manager)"
  },
  {
    "onetCode": "11-3121.00",
    "title": "HR Ops Manager (Human Resources Operations Manager)"
  },
  {
    "onetCode": "11-3121.00",
    "title": "HR VP (Human Resources Vice President)"
  },
  {
    "onetCode": "11-3121.00",
    "title": "Recruitment Director"
  },
  {
    "onetCode": "13-1071.00",
    "title": "Corporate Recruiter"
  },
  {
    "onetCode": "13-1071.00",
    "title": "Employment Representative"
  },
  {
    "onetCode": "13-1071.00",
    "title": "HR Analyst (Human Resources Analyst)"
  },
  {
    "onetCode": "13-1071.00",
    "title": "HR Coordinator (Human Resources Coordinator)"
  },
  {
    "onetCode": "13-1071.00",
    "title": "HR Generalist (Human Resources Generalist)"
  },
  {
    "onetCode": "13-1071.00",
    "title": "Human Resources Representative (HR Rep)"
  },
  {
    "onetCode": "13-1071.00",
    "title": "Human Resources Specialist (HR Specialist)"
  },
  {
    "onetCode": "13-1071.00",
    "title": "Personnel Analyst"
  },
  {
    "onetCode": "13-1111.00",
    "title": "Administrative Analyst"
  },
  {
    "onetCode": "13-1111.00",
    "title": "Business Analyst"
  },
  {
    "onetCode": "13-1111.00",
    "title": "Business Consultant"
  },
  {
    "onetCode": "13-1111.00",
    "title": "Employment Programs Analyst"
  },
  {
    "onetCode": "13-1111.00",
    "title": "Management Analyst"
  },
  {
    "onetCode": "13-1111.00",
    "title": "Management Consultant"
  },
  {
    "onetCode": "13-1111.00",
    "title": "Organizational Development Consultant"
  },
  {
    "onetCode": "13-1111.00",
    "title": "Performance Management Analyst"
  },
  {
    "onetCode": "13-1151.00",
    "title": "Computer Training Specialist"
  },
  {
    "onetCode": "13-1151.00",
    "title": "Corporate Trainer"
  },
  {
    "onetCode": "13-1151.00",
    "title": "Job Training Specialist"
  },
  {
    "onetCode": "13-1151.00",
    "title": "Leadership Development Specialist"
  },
  {
    "onetCode": "13-1151.00",
    "title": "Learning and Development Consultant"
  },
  {
    "onetCode": "13-1151.00",
    "title": "Learning and Development Specialist (L and D Specialist)"
  },
  {
    "onetCode": "13-1151.00",
    "title": "Management Development Specialist"
  },
  {
    "onetCode": "13-1151.00",
    "title": "Trainer"
  },
  {
    "onetCode": "13-2011.00",
    "title": "Accountant"
  },
  {
    "onetCode": "13-2011.00",
    "title": "Accounting Officer"
  },
  {
    "onetCode": "13-2011.00",
    "title": "Audit Partner"
  },
  {
    "onetCode": "13-2011.00",
    "title": "Auditor"
  },
  {
    "onetCode": "13-2011.00",
    "title": "Cost Accountant"
  },
  {
    "onetCode": "13-2011.00",
    "title": "CPA (Certified Public Accountant)"
  },
  {
    "onetCode": "13-2011.00",
    "title": "Financial Auditor"
  },
  {
    "onetCode": "13-2011.00",
    "title": "Financial Reporting Accountant"
  },
  {
    "onetCode": "13-2051.00",
    "title": "Analyst"
  },
  {
    "onetCode": "13-2051.00",
    "title": "Credit Products Officer"
  },
  {
    "onetCode": "13-2051.00",
    "title": "Equity Research Analyst"
  },
  {
    "onetCode": "13-2051.00",
    "title": "Financial Analyst"
  },
  {
    "onetCode": "13-2051.00",
    "title": "Investment Analyst"
  },
  {
    "onetCode": "13-2051.00",
    "title": "Planning Analyst"
  },
  {
    "onetCode": "13-2051.00",
    "title": "Portfolio Manager"
  },
  {
    "onetCode": "13-2051.00",
    "title": "Real Estate Analyst"
  },
  {
    "onetCode": "15-1211.00",
    "title": "Applications Analyst"
  },
  {
    "onetCode": "15-1211.00",
    "title": "Business Systems Analyst"
  },
  {
    "onetCode": "15-1211.00",
    "title": "Computer Analyst"
  },
  {
    "onetCode": "15-1211.00",
    "title": "Computer Systems Analyst"
  },
  {
    "onetCode": "15-1211.00",
    "title": "Computer Systems Consultant"
  },
  {
    "onetCode": "15-1211.00",
    "title": "Information Systems Analyst (ISA)"
  },
  {
    "onetCode": "15-1211.00",
    "title": "IT Analyst (Information Technology Analyst)"
  },
  {
    "onetCode": "15-1211.00",
    "title": "IT Systems Analyst (Information Technology Systems Analyst)"
  },
  {
    "onetCode": "15-1211.01",
    "title": "Clinical Electronic Health Record Nurse (Clinical EHR Nurse)"
  },
  {
    "onetCode": "15-1211.01",
    "title": "Clinical Informaticist"
  },
  {
    "onetCode": "15-1211.01",
    "title": "Clinical Informatics Analyst"
  },
  {
    "onetCode": "15-1211.01",
    "title": "Clinical Informatics Nurse"
  },
  {
    "onetCode": "15-1211.01",
    "title": "Clinical Informatics Specialist"
  },
  {
    "onetCode": "15-1211.01",
    "title": "Health Informaticist"
  },
  {
    "onetCode": "15-1211.01",
    "title": "Nursing Informatics Officer"
  },
  {
    "onetCode": "15-1211.01",
    "title": "Nursing Informatics Specialist"
  },
  {
    "onetCode": "15-1232.00",
    "title": "Computer Support Specialist"
  },
  {
    "onetCode": "15-1232.00",
    "title": "Computer Tech (Computer Technician)"
  },
  {
    "onetCode": "15-1232.00",
    "title": "Desktop Support Technician (Desktop Support Tech)"
  },
  {
    "onetCode": "15-1232.00",
    "title": "Help Desk Analyst"
  },
  {
    "onetCode": "15-1232.00",
    "title": "Help Desk Tech (Help Desk Technician)"
  },
  {
    "onetCode": "15-1232.00",
    "title": "IS Tech (Information Systems Technician)"
  },
  {
    "onetCode": "15-1232.00",
    "title": "IT Specialist (Information Technology Specialist)"
  },
  {
    "onetCode": "15-1232.00",
    "title": "IT Support Specialist (Information Technology Support Specialist)"
  },
  {
    "onetCode": "15-1244.00",
    "title": "LAN Administrator (Local Area Network Administrator)"
  },
  {
    "onetCode": "15-1244.00",
    "title": "LAN Specialist (Local Area Network Specialist)"
  },
  {
    "onetCode": "15-1244.00",
    "title": "Network Administrator (Network Admin)"
  },
  {
    "onetCode": "15-1244.00",
    "title": "Network Analyst"
  },
  {
    "onetCode": "15-1244.00",
    "title": "Network Coordinator"
  },
  {
    "onetCode": "15-1244.00",
    "title": "Network Engineer"
  },
  {
    "onetCode": "15-1244.00",
    "title": "Network Manager"
  },
  {
    "onetCode": "15-1244.00",
    "title": "Network Specialist"
  },
  {
    "onetCode": "15-1252.00",
    "title": "Application Developer"
  },
  {
    "onetCode": "15-1252.00",
    "title": "Application Integration Engineer"
  },
  {
    "onetCode": "15-1252.00",
    "title": "Developer"
  },
  {
    "onetCode": "15-1252.00",
    "title": "DevOps Engineer (Development Operations Engineer)"
  },
  {
    "onetCode": "15-1252.00",
    "title": "Infrastructure Engineer"
  },
  {
    "onetCode": "15-1252.00",
    "title": "Software Architect"
  },
  {
    "onetCode": "15-1252.00",
    "title": "Software Developer"
  },
  {
    "onetCode": "15-1252.00",
    "title": "Software Development Engineer"
  },
  {
    "onetCode": "23-1011.00",
    "title": "Attorney"
  },
  {
    "onetCode": "23-1011.00",
    "title": "Attorney at Law"
  },
  {
    "onetCode": "23-1011.00",
    "title": "Attorney General"
  },
  {
    "onetCode": "23-1011.00",
    "title": "Counsel"
  },
  {
    "onetCode": "23-1011.00",
    "title": "County Attorney"
  },
  {
    "onetCode": "23-1011.00",
    "title": "District Attorney"
  },
  {
    "onetCode": "23-1011.00",
    "title": "General Counsel"
  },
  {
    "onetCode": "23-1011.00",
    "title": "Lawyer"
  },
  {
    "onetCode": "41-4012.00",
    "title": "Account Representative"
  },
  {
    "onetCode": "41-4012.00",
    "title": "Customer Account Technician"
  },
  {
    "onetCode": "41-4012.00",
    "title": "Inside Salesperson"
  },
  {
    "onetCode": "41-4012.00",
    "title": "Outside Sales Representative"
  },
  {
    "onetCode": "41-4012.00",
    "title": "Route Sales Representative"
  },
  {
    "onetCode": "41-4012.00",
    "title": "Sales Consultant"
  },
  {
    "onetCode": "41-4012.00",
    "title": "Sales Professional"
  },
  {
    "onetCode": "41-4012.00",
    "title": "Sales Representative (Sales Rep)"
  },
  {
    "onetCode": "43-1011.00",
    "title": "Accounting Manager"
  },
  {
    "onetCode": "43-1011.00",
    "title": "Accounts Payable Supervisor"
  },
  {
    "onetCode": "43-1011.00",
    "title": "Accounts Receivable Manager"
  },
  {
    "onetCode": "43-1011.00",
    "title": "Administrative Supervisor"
  },
  {
    "onetCode": "43-1011.00",
    "title": "Customer Service Manager"
  },
  {
    "onetCode": "43-1011.00",
    "title": "Customer Service Supervisor"
  },
  {
    "onetCode": "43-1011.00",
    "title": "Office Coordinator"
  },
  {
    "onetCode": "43-1011.00",
    "title": "Office Manager"
  },
  {
    "onetCode": "43-3021.00",
    "title": "Biller"
  },
  {
    "onetCode": "43-3021.00",
    "title": "Billing Accounts Representative"
  },
  {
    "onetCode": "43-3021.00",
    "title": "Billing Clerk"
  },
  {
    "onetCode": "43-3021.00",
    "title": "Billing Coordinator"
  },
  {
    "onetCode": "43-3021.00",
    "title": "Billing Specialist"
  },
  {
    "onetCode": "43-3021.00",
    "title": "IP Clerk (Item Processing Clerk)"
  },
  {
    "onetCode": "43-3021.00",
    "title": "Pre Audit Clerk"
  },
  {
    "onetCode": "43-3021.00",
    "title": "Statement Clerk"
  },
  {
    "onetCode": "43-3031.00",
    "title": "Account Clerk"
  },
  {
    "onetCode": "43-3031.00",
    "title": "Accounting Assistant"
  },
  {
    "onetCode": "43-3031.00",
    "title": "Accounting Associate"
  },
  {
    "onetCode": "43-3031.00",
    "title": "Accounting Clerk"
  },
  {
    "onetCode": "43-3031.00",
    "title": "Accounting Specialist"
  },
  {
    "onetCode": "43-3031.00",
    "title": "Accounting Technician"
  },
  {
    "onetCode": "43-3031.00",
    "title": "Accounts Payable Clerk"
  },
  {
    "onetCode": "43-3031.00",
    "title": "Accounts Payable Specialist"
  },
  {
    "onetCode": "43-3051.00",
    "title": "Payroll Assistant"
  },
  {
    "onetCode": "43-3051.00",
    "title": "Payroll Clerk"
  },
  {
    "onetCode": "43-3051.00",
    "title": "Payroll Coordinator"
  },
  {
    "onetCode": "43-3051.00",
    "title": "Payroll Representative"
  },
  {
    "onetCode": "43-3051.00",
    "title": "Payroll Specialist"
  },
  {
    "onetCode": "43-3051.00",
    "title": "Payroll Technician"
  },
  {
    "onetCode": "43-3051.00",
    "title": "Personnel Assistant"
  },
  {
    "onetCode": "43-3051.00",
    "title": "Personnel Technician"
  },
  {
    "onetCode": "43-4051.00",
    "title": "Account Representative"
  },
  {
    "onetCode": "43-4051.00",
    "title": "Call Center Representative"
  },
  {
    "onetCode": "43-4051.00",
    "title": "Client Services Representative"
  },
  {
    "onetCode": "43-4051.00",
    "title": "Customer Care Representative (CCR)"
  },
  {
    "onetCode": "43-4051.00",
    "title": "Customer Service Agent"
  },
  {
    "onetCode": "43-4051.00",
    "title": "Customer Service Representative (CSR)"
  },
  {
    "onetCode": "43-4051.00",
    "title": "Customer Service Specialist"
  },
  {
    "onetCode": "43-4051.00",
    "title": "Customer Support Representative (Customer Support Rep)"
  },
  {
    "onetCode": "43-4161.00",
    "title": "Human Resources Administrative Assistant (HR Administrative Assistant)"
  },
  {
    "onetCode": "43-4161.00",
    "title": "Human Resources Assistant (HR Assistant)"
  },
  {
    "onetCode": "43-4161.00",
    "title": "Human Resources Associate (HR Associate)"
  },
  {
    "onetCode": "43-4161.00",
    "title": "Personnel Clerk"
  },
  {
    "onetCode": "43-6011.00",
    "title": "Administrative Aide"
  },
  {
    "onetCode": "43-6011.00",
    "title": "Administrative Assistant"
  },
  {
    "onetCode": "43-6011.00",
    "title": "Administrative Associate"
  },
  {
    "onetCode": "43-6011.00",
    "title": "Administrative Coordinator"
  },
  {
    "onetCode": "43-6011.00",
    "title": "Administrative Secretary"
  },
  {
    "onetCode": "43-6011.00",
    "title": "Administrative Specialist"
  },
  {
    "onetCode": "43-6011.00",
    "title": "Executive Administrative Assistant"
  },
  {
    "onetCode": "43-6011.00",
    "title": "Executive Assistant"
  },
  {
    "onetCode": "43-6014.00",
    "title": "Administrative Assistant (Admin Assistant)"
  },
  {
    "onetCode": "43-6014.00",
    "title": "Administrative Clerk"
  },
  {
    "onetCode": "43-6014.00",
    "title": "Administrative Secretary (Admin Secretary)"
  },
  {
    "onetCode": "43-6014.00",
    "title": "Administrative Specialist (Admin Specialist)"
  },
  {
    "onetCode": "43-6014.00",
    "title": "Administrative Support Assistant (ASA)"
  },
  {
    "onetCode": "43-6014.00",
    "title": "Administrative Technician"
  },
  {
    "onetCode": "43-6014.00",
    "title": "Department Secretary"
  },
  {
    "onetCode": "43-6014.00",
    "title": "Office Assistant"
  },
  {
    "onetCode": "43-9061.00",
    "title": "Administrative Clerk (Admin Clerk)"
  },
  {
    "onetCode": "43-9061.00",
    "title": "Clerical Aide"
  },
  {
    "onetCode": "43-9061.00",
    "title": "Clerical Assistant"
  },
  {
    "onetCode": "43-9061.00",
    "title": "Clerk"
  },
  {
    "onetCode": "43-9061.00",
    "title": "General Clerk"
  },
  {
    "onetCode": "43-9061.00",
    "title": "Office Assistant"
  },
  {
    "onetCode": "43-9061.00",
    "title": "Office Clerk"
  },
  {
    "onetCode": "43-9061.00",
    "title": "Office Services Specialist"
  },
  {
    "onetCode": "53-3032.00",
    "title": "CDL Driver (Commercial Driver's License Driver)"
  },
  {
    "onetCode": "53-3032.00",
    "title": "Driver"
  },
  {
    "onetCode": "53-3032.00",
    "title": "Line Haul Driver"
  },
  {
    "onetCode": "53-3032.00",
    "title": "Log Truck Driver"
  },
  {
    "onetCode": "53-3032.00",
    "title": "Over the Road Driver (OTR Driver)"
  },
  {
    "onetCode": "53-3032.00",
    "title": "Production Truck Driver"
  },
  {
    "onetCode": "53-3032.00",
    "title": "Road Driver"
  },
  {
    "onetCode": "53-3032.00",
    "title": "Semi Truck Driver"
  }
];
